import React from 'react';

const ProgressSteps = ({ currentStep, totalSteps = 3 }) => {
  return (
    <div className="flex items-center justify-center mb-8">
      <div className="flex items-center">
        {Array.from({ length: totalSteps }, (_, index) => (
          <React.Fragment key={index}>
            <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold ${
              currentStep >= index + 1 ? 'bg-[#075e54]' : 'bg-gray-300'
            }`}>
              {index + 1}
            </div>
            {index < totalSteps - 1 && (
              <div className={`w-16 h-1 mx-2 ${
                currentStep >= index + 2 ? 'bg-[#075e54]' : 'bg-gray-300'
              }`}></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressSteps;

